import { Box, styled } from '@mui/material'
import { RequiredAuth } from 'components/Layout'
import { BackgroundSystem } from 'layouts'
import React from 'react'

const ContentOutletWrapper = styled(Box)(({theme}) => ({
    display: 'flex',
    flex: 1,
    position: 'relative',
    overflowX: 'hidden'
}))

const ContentOutlet = () => {
    return (
        <ContentOutletWrapper>
            <BackgroundSystem />
            <Box sx={{ position: 'relative', flex: 1, overflowX: 'hidden' }}>
                <RequiredAuth />
            </Box>
        </ContentOutletWrapper>
    )
}

export default ContentOutlet